import { useState, useEffect, useContext } from 'react';
import { useUserStore } from '../stores/userStore';

import CardContext from '../context/CardContext';
import CardNew from './cardNew';
import CardNote from './cardNote';
import CardWeather from './cardWeather';
import Card from './card';


function CardList() {
    const editMode = useUserStore(state => state.editMode)
    const cardCols = useUserStore(state => state.cardCols)
    const displayNote = useUserStore(state => state.displayNote)
    const displayCards = useUserStore(state => state.displayCards)
    const displayWeather = useUserStore(state => state.displayWeather)

    const { cards } = useContext(CardContext);

    const [ modeDelayed, setModeDelayed ] = useState();
    const [ display, setDisplay ] = useState('none');
    
    const [editFieldsVisible, setEditFieldsVisible] = useState(false);

    const handleAddFieldsToggle = () => {
        setEditFieldsVisible(editFieldsVisible ? false : true);
    }

    useEffect( () => {
        if(editMode === true) { 
            enterEditMode(); 
            return; 
        }

        leaveEditMode();
        setEditFieldsVisible(false);
        return;

    }, [editMode]);


    const enterEditMode = () => {
        setDisplay('block');
        setTimeout(() => {
            setModeDelayed('edit');
        }, 1);
    }

    const leaveEditMode = () => {
        setModeDelayed('');
        setTimeout( () => {
            setDisplay('none');
        }, 151)
    }

    return (
        <ul className={`card-list ${modeDelayed}`} style={{'--cols' : cardCols }}>
            {displayWeather ? <CardWeather columns={cardCols} />: ''}
            {displayNote ? <CardNote columns={cardCols} />: ''}
            {displayCards ? cards.map( ( { img, link, title, text }, index ) => {
                return(
                    <Card key={index} index={index} img={img} title={title} text={text} link={link} />
                );
            }) : ''}
            {display === 'none' ? '' : <CardNew card display={display} editVisible={editFieldsVisible} handleVisibilityUpdate={handleAddFieldsToggle}  />}
        </ul>
    );
  }
  
  export default CardList;
  